module.exports = __webpack_public_path__ + "static/media/math-transparent.56059867.svg";